import React from 'react';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import { useTranslation } from 'react-i18next';
import {ObjectTypeEnum} from "@constants/objectType";
import {InspectedObjectDetailsDTO} from "@api/objectDetails/dto/InspectedObjectDetailsDTO";
import LiftingObjectDetails from './LiftingObjectDetails';
import ElectricalObjectDetails from './ElectricalObjectDetails';

type Props = {
  objectDetailsDTO: InspectedObjectDetailsDTO;
};

function InspectedObjectDetails({objectDetailsDTO} : Props) {
  const { t } = useTranslation();

  return (
    <AccordionWrapper
      accordionTitle={t('report.details.object.details.title')}
      className="containerReducedWhiteSpace"
      render={() =>
        objectDetailsDTO.objectType === ObjectTypeEnum.EQUIPMENT ? (
          <LiftingObjectDetails objectDetailsDTO={objectDetailsDTO} />
        ) : (
          <ElectricalObjectDetails objectDetailsDTO={objectDetailsDTO} />
        )
      }
    />
  );
}

export default InspectedObjectDetails;
